import {
  ThemePerformanceSortHorizon,
  ThemePerformanceSubClass,
  ThemeTimeseriesV5Response,
  themeOverview,
} from '@api';
import { useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

const QUERY_KEY_GET_V7_THEME_PERFORMANCE_TIMESERIES =
  'QUERY_KEY_GET_V7_THEME_PERFORMANCE_TIMESERIES';

export const useV7ThemePerformanceTimeseries = (
  {
    themeId,
    horizon,
    subClass,
  }: {
    themeId: string;
    horizon: ThemePerformanceSortHorizon;
    subClass?: ThemePerformanceSubClass;
  },
  enabled = true
) =>
  useQuery({
    queryKey: [
      QUERY_KEY_GET_V7_THEME_PERFORMANCE_TIMESERIES,
      themeId,
      horizon,
      subClass,
    ],
    queryFn: ({ signal }) =>
      wretchRequest<ThemeTimeseriesV5Response>(
        themeOverview.getV7ThemePerformanceTimeseries.path({
          themeId,
          horizon,
          subClass,
        }),
        {
          schema: themeOverview.getV7ThemePerformanceTimeseries.schema,
          signal,
        }
      ),
    enabled,
  });
